import { CalendarProvider } from './calendarProvider.types'

export const getAvailableProviders = (calendarIntegration: string[] | null | undefined): CalendarProvider[] => {
  if (!calendarIntegration) return []
  const providers: CalendarProvider[] = []

  if (calendarIntegration.includes(CalendarProvider.GOOGLE)) {
    providers.push(CalendarProvider.GOOGLE)
  }

  if (calendarIntegration.includes(CalendarProvider.OUTLOOK)) {
    providers.push(CalendarProvider.OUTLOOK)
  }

  return providers
}

export const isProviderConnected = (providers: string[], provider: CalendarProvider): boolean => {
  return providers.includes(provider)
}
